<template>
  <div class="container">
    <!-- 头部区域 -->
    <header class="header">
      <img 
        v-if="domainData.avatar" 
        :src="domainData.avatar" 
        class="logo"
      >
      <h1 v-if="domainData.siteName" class="title">{{ domainData.siteName }}</h1>
    </header>

    <!-- 使用 Element Plus 实现的登录框 -->
    <div class="login-content">
			<div class="login-content-main">
				<h4 class="login-content-title">{{ domainData.siteName }}</h4>
				<div>
          <el-form ref="loginAccountRef" size="default" :model="loginForm" class="login-content-form">
            <el-form-item class="login-animation2" prop="loginName">
              <el-input type="text" placeholder="请输入登录账号" :model="loginForm.loginName" clearable autocomplete="off">
              </el-input>
            </el-form-item>
            <el-form-item class="login-animation3" prop="password">
              <el-input type="password" placeholder="请输入登录密码" :model="loginForm.password" clearable autocomplete="off">
              </el-input>
            </el-form-item>
            <el-form-item class="login-animation5">
              <el-button type="primary" class="login-content-submit" round>
                <span>登 录</span>
              </el-button>
            </el-form-item>
            <div class="font12 login-animation5 login-msg">* 温馨提示：建议使用Edge ≥ 79、Firefox ≥ 78、Chrome ≥ 64、Safari ≥ 12及以上的浏览器，360浏览器请使用极速模式。</div>
          </el-form>
        </div>
			</div>
		</div>

    <!-- 底部备案信息 -->
    <footer class="footer">
      <p v-if="domainData.icpRecord" class="record">
        <a href="https://beian.miit.gov.cn" target="_blank">{{ domainData.icpRecord }}</a>
      </p>
      <p v-if="domainData.wanRecord" class="record">
        <a href="https://beian.mps.gov.cn" target="_blank"><img src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png" alt="备案图标" width="18px" /> {{ domainData.wanRecord }}</a>
      </p>
    </footer>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      domainData: {
        id: "",
        domainName: "",
        siteName: "",
        icpRecord: "",
        wanRecord: "",
        avatar: ""
      },
      loginForm: {
        username: '',
        password: ''
      }
    }
  },
  mounted() {
    this.getDomainConfig()
  },
  methods: {
    async getDomainConfig() {
      const currentDomain = window.location.hostname;
      try {
        const response = await axios.get(`/wlcrm/api-crm/domain/config/match`, {
          params: { name: currentDomain }
        });
        if (!response.data.data || Object.keys(response.data.data).length === 0) {
          window.location.href = '/404.html';
          return;
        }
        // 调整数据结构映射
        this.domainData = { 
          ...response.data.data, // 直接使用返回的数据
        };
        document.title = this.domainData.siteName; // 使用新的站点名称字段
      } catch (error) {
        console.error('Error fetching domain config:', error);
        //跳转到404.html
        window.location.href = '/404.html';
      }
    }
  }
}
</script>

<style>
/* 容器样式 */
.container {
  height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background-image: url('https://sq.wuling101.cn/wlcrm/api-system/bing/image/preview/today');
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  flex-direction: column;
}

/* 头部布局优化 */
.header {
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 20px;
}

.logo {
  height: 60px;
  max-width: 240px;
  object-fit: contain;
}

.title {
  margin: 0;
  color: #fff;
  font-size: 32px;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
}

/* 底部信息优化 */
.footer {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  color: #fff;
  background: rgba(0,0,0,0.3);
  padding: 12px 30px;
  border-radius: 6px;
}

.record {
  margin: 8px 0;
  font-size: 16px;
  white-space: nowrap;
}

.login-content {
  width: 430px;
  padding: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) translate3d(0, 0, 0);
  background: rgba(255, 255, 255, 0.5);
  /* background-color: var(--el-color-white); */
  border: 5px solid var(--el-color-primary-light-8);
  border-radius: 4px;
  transition: height 0.2s linear;
  min-height: 300px;
  overflow: hidden;
  z-index: 1;
  .login-content-main {
    margin: 0 auto;
    width: 80%;
    .login-content-title {
      height: 50px;
      color: var(--el-text-color-primary);
      font-weight: 500;
      font-size: 22px;
      text-align: center;
      letter-spacing: 4px;
      margin: 5px 0 10px;
      white-space: nowrap;
      z-index: 5;
      position: relative;
      transition: all 0.3s ease;
    }
  }
  .login-content-main-sacn {
    position: absolute;
    top: 0;
    right: 0;
    width: 50px;
    height: 50px;
    overflow: hidden;
    cursor: pointer;
    transition: all ease 0.3s;
    color: var(--el-text-color-primary);
    &-delta {
      position: absolute;
      width: 35px;
      height: 70px;
      z-index: 2;
      top: 2px;
      right: 21px;
      background: var(--el-color-white);
      transform: rotate(-45deg);
    }
    &:hover {
      opacity: 1;
      transition: all ease 0.3s;
      color: var(--el-color-primary) !important;
    }
    i {
      width: 47px;
      height: 50px;
      display: inline-block;
      font-size: 48px;
      position: absolute;
      right: 2px;
      top: -1px;
    }
  }
  .login-content-submit {
    width: 100%;
    height: 40px;
    font-size: 18px;
  }
}

.font12 {
  font-size: 12px !important;
  color: #fff;
}
/* 去掉 a 链接下划线 */
a {
  text-decoration: none;
  color: #fff; /* 可选：设置链接颜色 */
}
/* 让 a 标签内的图片和文字垂直居中 */
footer a {
  display: inline-flex;
  align-items: center;
  gap: 5px; /* 可根据需要调整图片和文字之间的间距 */
}
</style>